export default __webpack_public_path__ + "media/Desire-1.3bbf72a2.svg";